module.exports = __webpack_public_path__ + "img/monarch-ui-icon_FUNCTION.14e9b5fe.png";